import {
    INIT_MEDICAL_AGENDA,
    MEDICAL_AGENDA,
    ERROR_MEDICAL_AGENDA,
    INIT_SAVE_RESULT_TEST,
    SAVE_RESULT_TEST,
    ERROR_SAVE_RESULT_TEST,
} from 'happ-redux/happ-types';

const initialState = {
    loading: false,
    medical_agenda: null,
    determinations: null,
    allGoodStatus: false,
    error_server_agenda: null
}

export default function(state = initialState, action){
    switch(action.type){
        case INIT_MEDICAL_AGENDA:
        case INIT_SAVE_RESULT_TEST:    
            return {
                ...state,
                loading: true,
            }
        case MEDICAL_AGENDA:
            return {
                ...state,
                loading: false,
                error_server_agenda: false,
                determinations: action.payload.determinations,
                medical_agenda: action.payload.medicalAgenda,
                allGoodStatus: action.payload.allGoodStatus
            }
        case ERROR_MEDICAL_AGENDA: 
            return {
                ...state,
                loading: false,
                medical_agenda: null,
                determinations: null,
                error_server_agenda: action.payload
            }
        case SAVE_RESULT_TEST:
            return {
                ...state,
                loading: false,
                medical_agenda: action.payload.response,
                error_server_agenda: null
            }
        case ERROR_SAVE_RESULT_TEST:
            return {
                ...state,
                loading: false,
                error_server_agenda: action.payload,
            }   
        default:
            return state
    }
}